import React, { useState } from 'react';
import { useDrag } from 'react-dnd';
import { Info } from 'lucide-react';

const ModuleTile = ({ module }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'module',
    item: { id: module.id, name: module.name },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const handleMouseEnter = (e) => {
    if (!isDragging) {
      const rect = e.currentTarget.getBoundingClientRect();
      setTooltipPosition({
        x: rect.left - 300, // Position à gauche du module
        y: rect.top
      });
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  // Masquer le tooltip pendant le drag
  React.useEffect(() => {
    if (isDragging) {
      setShowTooltip(false);
    }
  }, [isDragging]);

  const moduleClass = `module-${module.id}`;
  
  return (
    <>
      <div
        ref={drag}
        className={`module-tile ${moduleClass} ${isDragging ? 'opacity-50' : ''}`}
        data-testid={`module-${module.id}`}
      >
        <div className="module-number">{module.id}</div>
        <div className="module-name">{module.short_name}</div>
        <div 
          className="info-icon"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Info size={12} />
        </div>
      </div>
      
      {showTooltip && !isDragging && module.tooltip && (
        <div 
          className="tooltip"
          style={{
            position: 'fixed',
            left: Math.max(10, tooltipPosition.x),
            top: tooltipPosition.y,
            zIndex: 1000,
            maxWidth: '280px'
          }}
        >
          <div style={{ padding: '8px 0' }}>
            {module.tooltip.map((item, index) => (
              <div key={index} style={{ marginBottom: '4px' }}>- {item}</div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ModuleTile;